import React from 'react';
import { Routes } from './routes';


export const App = () =>   <Routes/>
  


